import { FormEvent, useState } from 'react'
import { Alerta, AreaTexto, Boton, Campo, Dialogo, Seleccion } from '../kit'
import { useMarcarPlancheta } from '../../queries/useInventario'
import { EstadoPlancheta, Recinto } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'
import { PLANCHETA } from '../../utils/inventario'

/** Cambiar a mano el estado de la plancheta (p. ej. firmada sin reimprimir, o empezar una revisión nueva). */
export function DialogoPlancheta({ recinto, onCerrar }: { recinto: Recinto; onCerrar: () => void }) {
  const marcar = useMarcarPlancheta()
  const [estado, setEstado] = useState<EstadoPlancheta>(recinto.plancheta_estado === 'ACTUALIZADA' ? 'DESACTUALIZADA' : 'ACTUALIZADA')
  const [nota, setNota] = useState('')
  const guardar = (e: FormEvent) => {
    e.preventDefault()
    marcar.mutate({ codigo: recinto.codigo, estado, nota }, { onSuccess: onCerrar })
  }
  return (
    <Dialogo abierto onCerrar={onCerrar} titulo="Marcar la plancheta">
      <form className="pila" onSubmit={guardar}>
        <p className="texto-secundario">Hoy está {PLANCHETA[recinto.plancheta_estado].texto.toLowerCase()}. El cambio queda en el historial de la oficina.</p>
        <Campo etiqueta="Nuevo estado">
          <Seleccion value={estado} onChange={(e) => setEstado(e.target.value as EstadoPlancheta)}>
            {(Object.keys(PLANCHETA) as EstadoPlancheta[]).map((clave) => (
              <option key={clave} value={clave}>{PLANCHETA[clave].texto}</option>
            ))}
          </Seleccion>
        </Campo>
        <Campo etiqueta="Nota" ayuda="Opcional. Por ejemplo: «Firmada por el encargado» o «Revisión 2027».">
          <AreaTexto rows={2} value={nota} onChange={(e) => setNota(e.target.value)} />
        </Campo>
        {marcar.isError && <Alerta tipo="error">{mensajeDeError(marcar.error)}</Alerta>}
        <div className="acciones-formulario">
          <Boton variante="text" onClick={onCerrar}>Cancelar</Boton>
          <Boton type="submit" cargando={marcar.isPending} disabled={estado === recinto.plancheta_estado}>Marcar</Boton>
        </div>
      </form>
    </Dialogo>
  )
}
